// components/cart/BranchSelector.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSucursal } from 'store/carritoSlice';
import { obtenerSucursales } from 'scripts/obtenerSucursales';
import tw from 'twin.macro';
import styled from 'styled-components';

const Container = tw.div`flex flex-col w-full mb-6`;
const Title = tw.h3`text-xl font-bold mb-3`;
const SucursalesList = tw.div`flex flex-col gap-3`;

const SucursalCard = styled.div`
	${tw`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200`}
	${(props) => (props.selected ? tw`border-blue-600 bg-blue-100` : tw`border-gray-300 hover:border-blue-400`)}
`;

const SucursalName = tw.h4`text-lg font-semibold mb-1`;
const SucursalInfo = tw.p`text-sm text-gray-600`;
const PickupMessage = tw.p`text-sm text-blue-700 mt-2`;
const ErrorMessage = tw.p`text-red-600 text-sm`;
const LoadingMessage = tw.p`text-gray-600 text-sm`;

const BranchSelector = () => {
	const dispatch = useDispatch();
	const sucursales = useSelector((state) => state.sucursales);
	const sucursalIdSeleccionada = useSelector((state) => state.carrito.sucursalId);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchSucursales = async () => {
			try {
				setLoading(true);
				await obtenerSucursales(dispatch);
				setError(null);
			} catch (err) {
				console.error('Error al cargar sucursales:', err);
				setError('No se pudieron cargar las sucursales. Por favor, intenta de nuevo.');
			} finally {
				setLoading(false);
			}
		};

		if (sucursales.length === 0) {
			fetchSucursales();
		} else {
			setLoading(false);
		}
	}, [dispatch, sucursales.length]);

	const handleSelectSucursal = (sucursalId) => {
		dispatch(setSucursal(sucursalId));
	};
	if (loading) {
		return (
			<Container>
				<Title>Selecciona una sucursal para retiro</Title>
				<LoadingMessage>Cargando sucursales...</LoadingMessage>
			</Container>
		);
	}

	if (error) {
		return (
			<Container>
				<Title>Selecciona una sucursal para retiro</Title>
				<ErrorMessage>{error}</ErrorMessage>
			</Container>
		);
	}

	if (sucursales.length === 0) {
		return (
			<Container>
				<Title>Selecciona una sucursal para retiro</Title>
				<ErrorMessage>No hay sucursales disponibles en este momento.</ErrorMessage>
			</Container>
		);
	}

	return (
		<Container>
			<Title>Selecciona una sucursal para retiro</Title>
			<SucursalesList>
				{sucursales.map((sucursal) => (
					<SucursalCard
						key={sucursal.id}
						selected={sucursalIdSeleccionada === sucursal.id}
						onClick={() => handleSelectSucursal(sucursal.id)}
					>
						<SucursalName>{sucursal.nombre}</SucursalName>
						<SucursalInfo>📍 {sucursal.direccion}</SucursalInfo>
						{sucursal.mensaje_retiro && <PickupMessage>{sucursal.mensaje_retiro}</PickupMessage>}
						{sucursal.telefono && <SucursalInfo>☎️ {sucursal.telefono}</SucursalInfo>}
					</SucursalCard>
				))}
			</SucursalesList>
		</Container>
	);
};

export default BranchSelector;
